import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 16v-8l4 8v-8","key":"svg-1"}]]

const IconCircleLetterN = createReactComponent('outline', 'circle-letter-n', 'CircleLetterN', __iconNode);

export default IconCircleLetterN;